import ReactApexChart from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import { Image } from "../../../../AbstractElements";
import { SocialWidgetData } from "../../../../Data/General/Widgets/General";
import { dynamicImage } from "../../../../Utils";
import { Fragment } from "react/jsx-runtime";

const SocialWidget = () => {
  return (
    <Fragment>
      {SocialWidgetData.map((item, index) => (
        <Col xl="3" sm="6" key={index}>
          <Card className="social-widget widget-hover">
            <CardBody>
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <div className="social-icons">
                    <Image src={dynamicImage(`general-widgets/social/${index + 1}.png`)} alt="facebook icon" />
                  </div>
                  <span className="f-w-500">{item.title}</span>
                </div>
                <span className={`font-${item.color} social-number`}>{item.percentage}</span>
              </div>
              <div className="social-content">
                <div>
                  <h5 className="mb-1">{item.text}</h5>
                  <span className="f-light f-w-500">{item.type}</span>
                </div>
                <div className="social-chart">
                  <ReactApexChart options={item.chart} series={item.chart?.series} type="radialBar" height={350} />
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Fragment>
  );
};

export default SocialWidget;
